import image, { CATEGORY_BANNER_BIG, PRODUCT_PHOTOGRAMME } from "lacinetek-common/src/images"

import { useTranslation } from "lib/i18n/translation"

import { Products, Slider } from "components/common"
import Image from "components/common/image"

export const Others = ({ clubs, current, showOther, loading }) => {
	if (loading) {
		return <section className="grey" />
	}

	const { c } = useTranslation("common")
	const withoutCurrentClub = clubs.filter(club => club.products.items.length && club.id !== current.id)

	if (withoutCurrentClub.length < 1) {
		return <section className="grey" />
	}

	return (
		<section className="grey">
			<h2 className="section-title icon-cine-club-previous">{c("previous-cine-club-strong")}</h2>
			<Slider
				slides={withoutCurrentClub}
				slideComponent={Slide}
				slidePropKey="club"
				slideRelatedProps={{
					clubs,
					showOther
				}}
				loading={loading}
				className="min"
				hidePagination
			/>
		</section>
	)
}

const Slide = ({ showOther, club, clubs, index }) => {
	const { c } = useTranslation("common")

	return (
		<Products
			products={club.products.items}
			logNoProducts={true}
			context="cine-club"
		>
			{([film], loading) => {
				if (!film || loading) {
					return null
				}

				return (
					<a
						href="#"
						onClick={e => {
							e.preventDefault()
							showOther(club, clubs, clubs.length - index)
						}}
						rel="nofollow noopener"
						title={c("see-cine-club")}
						data-overlay="#overlay-cine-club"
						className="slide-content"
					>
						<div className="slide-infos">
							<div className="infos">
								<h3 className="cine-club-title">
									{`CINE-CLUB #${clubs.length - index}`}
								</h3>
							</div>
							<figure>
								<picture>
									<Image
										src={!image(club, CATEGORY_BANNER_BIG).includes("default-banner")
											? image(club, CATEGORY_BANNER_BIG)
											: image(film, PRODUCT_PHOTOGRAMME)
										}
										alt={film.name}
									/>
								</picture>
							</figure>
						</div>
						<div className="slide-extras">
							<div className="infos">
								<span className="title">{film.name}</span>
								<span className="director">{c("of")} {film.director}</span>
								<p>{c("presented-by")} {club.descriptionShort}</p>
							</div>
						</div>
					</a>
				)
			}}
		</Products>
	)
}
